import ImportHelper from './import.helper'

const GeneralView = () => { return ImportHelper.importAll(require.context("../assets/images/GeneralView/", true, /\.webp/)); }
const Torre1 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre1/", true, /\.webp/)); }
const Torre2 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre2/", true, /\.webp/)); }
const Torre3 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre3/", true, /\.webp/)); }
const Torre4 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre4/", true, /\.webp/)); }
const Torre5 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre5/", true, /\.webp/)); }
const Torre6 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre6/", true, /\.webp/)); }
const Torre7 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre7/", true, /\.webp/)); }
const Torre8 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre8/", true, /\.webp/)); }
const Torre9 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre9/", true, /\.webp/)); }
const Torre10 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre10/", true, /\.webp/)); }
const Terreno = () => { return ImportHelper.importAll(require.context("../assets/images/Terreno/", true, /\.jpg/)); }

export const ContextLoader = {
    "General View": GeneralView,
    "Torre 1": Torre1,
    "Torre 2": Torre2,
    "Torre 3": Torre3,
    "Torre 4": Torre4,
    "Torre 5": Torre5,
    "Torre 6": Torre6,
    "Torre 7": Torre7,
    "Torre 8": Torre8,
    "Torre 9": Torre9,
    "Torre 10": Torre10,
    "Terreno": Terreno
}
